/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { buttonStyles, linkStyles, textStyles } from "utils/themeV2";


/* ++++++++++ --------------- EXPORT : AUTH COMPLETE PASSWORD RESET : STYLES --------------- ++++++++++ */
export default theme => ({
    completepasswordreset: {
        ...buttonStyles,
        ...linkStyles,
        ...textStyles
	}
});
